/**
 * Renders typography for different section elements based on the specified variant.
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode} [props.children=''] - Content to be rendered within the section typography.
 * @param {string} [props.variant='title'] - The variant of typography to be applied. Supported variants: 'title', 'subtitle', 'label'.
 * @returns {JSX.Element} Typography component for section elements.
 */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export default function Typography({ children = "", variant, style = {} }) {
    /**
   * Retrieves styles based on the specified variant.
   *
   * @returns {Object} Styles object containing typography properties.
   */ const getStyles = ()=>{
        switch(variant){
            case "title":
                return {
                    fontWeight: 400,
                    fontSize: "2.125rem",
                    lineHeight: 1.235,
                    letterSpacing: "0.00735em"
                };
            case "section":
                return {
                    fontSize: "1.5rem",
                    fontWeight: 500,
                    lineHeight: 1.235
                };
            case "subtitle":
                return {
                    fontSize: "1.2rem",
                    fontWeight: 400,
                    lineHeight: 1.3,
                    color: "#555"
                };
            case "label":
                return {
                    fontSize: "1rem",
                    fontWeight: 500,
                    lineHeight: 1.5,
                    color: "#888"
                };
            case "text":
            default:
                return {
                    fontWeight: "400",
                    fontSize: "1rem",
                    lineHeight: 1.5,
                    letterSpacing: "0.00938em"
                };
        }
    };
    const styles = {
        typography: _object_spread({}, getStyles(), style)
    };
    return /*#__PURE__*/ _jsx("div", {
        style: styles.typography,
        children: children
    });
}
